import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import MobligoLogo from "../../assets/img/mobligoLogo.svg";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppCard from '../../components/ui/AppCard';
import ChooseAppTopbar from './ChooseAppTopbar';
import MiniReport from './MiniReport';
import StepsMain from './OnBoarding/StepsMain';
import { useDispatch } from 'react-redux';
import myAppsSlice from '../../redux/myAppsSlice';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import CreateAction from '../../components/operational/createAction';
import dayjs from 'dayjs';
import { localeStringConverter } from '../../helper/Converters';
import { ProfileModal } from '../Profile';
import MyInput from '../../components/ui/MyInput';

const ChooseAppMain: FC = () => {
  const [filterString, setFilterString] = useState("")
  const [announcements, setAnnouncements] = useState([]);
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // apps = apps.concat(apps)
  const user: any = useSelector((state: any) => state.myUserSlice.user);
  const stores: any = useSelector((state: any) => state.myAppsSlice.localReduxData.stores);

  const checkAnnouncements = async () => {
    const response = await CreateAction({
      method: 'get',
      path: '/announcements',
      showPreLoader: false,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;
    const announcements = response?.result?.resultData;
    setAnnouncements(announcements);
    return null;
  };

  const chosedApp = (app: any) => {
    localStorage.setItem('activeStoreId', app?.id);

    dispatch(
      myAppsSlice.actions.setLocalReduxData({
        app,
      }),
    );
    localStorage.removeItem('themeId');
    window.location.href = '/dashboard';
  };

  useEffect(() => {
    checkAnnouncements();
  }, []);

  return (
    <>

      <ChooseAppTopbar setIsOpen={setIsOpen} user={user} />

      <div
        className="relative lg:h-screen flex flex-wrap w-[100%] overflow-auto !bg-[#F8F8F8] box-border gap-[20px] px-[33.8px] py-[26px]"
        style={{ height: 'calc(100vh - 90px)' }}
      >
        <div className="w-full md:w-[73%] bg-white rounded-[15px] md:px-5 md:py-7 ">
          <div className=' flex flex-row justify-between'>

            <div className="text-[14px] text-[#8A92A6] font-medium px-[15px] py-[5px] duration-100">
              Düzenlemek istediğiniz Native Uygulamanızı seçiniz.
            </div>
            <div className='max-w-[200px]'>
              <MyInput value={filterString} onChange={(e) => { setFilterString(e) }} placeholder='Filtre' />

            </div>
          </div>

          <div className="py-[15px] flex flex-wrap justify-center items-start mt-[10px] md:gap-y-[10px] md:gap-y-[20px] overflow-y-auto duration-100">
            <div
              className="flex flex-col w-[130px] gap-[5px] justify-center items-center cursor-pointer transition-transform duration-300 hover:scale-110"
              onClick={() => navigate('/createapp')}
            >
              <div className="w-[6rem] h-[6rem] flex justify-center items-center border-2 border-indigo-600 border-dashed border-[#E3E8EF] rounded-[10px] top-[0px]  duration-200">
                <FontAwesomeIcon
                  icon={faPlus}
                  className="items-center text-[22px] duration-100 text-indigo-600 group-hover:text-[#7059EF]"
                />
              </div>

              <div
                className={`text-indigo-600 text-[12px] w-[5rem] truncate text-center content-center rounded-[10px] `}
              >
                Oluştur
              </div>
            </div>
            {/* <div className="group cursor-pointer flex flex-col items-center justify-start w-[100px] h-[125px] gap-[5px] mr-[5px]" onClick={() => setOpenPopup(true)}>
              <div className="mt-[4px] w-[70px] h-[70px]  border border-dashed border-[#8A92A680] group-hover:border-[#7059EF] rounded-[10px] flex items-center justify-center duration-500 bg-[#F8F8F8] group-hover:bg-[#F0EEFC]">
                <FontAwesomeIcon
                  icon={faPlus}
                  className="text-[20px] duration-100 text-[#8A92A6] group-hover:text-[#7059EF]"
                />
              </div>
              <span className="text-[13px] duration-100  text-[#8A92A6] group-hover:text-[#7059EF]" id='openPop'>Oluştur</span>
            </div> */}
            {stores &&
              stores
                .slice()
                .sort((a: any, b: any) => a.mobileAppName.localeCompare(b.mobileAppName))
                .filter((app: any) => {
                  console.log(app.mobileAppName, filterString)
                  return !filterString || app?.mobileAppName?.toLowerCase()?.includes(filterString)
                })
                .map((app: any) => (
                  <AppCard
                    key={app.id}
                    app={{
                      ...app,
                      androidStatus: 'inReview',
                      iosStatus: 'unpublished',
                    }}
                    onClick={() => chosedApp(app)}
                  />
                ))}
          </div>
        </div>
        <div className="w:full md:w-[25%] bg-white rounded-[15px] md:px-5 md:py-7 ">
          <div className="text-[14px] text-[#8A92A6] font-medium px-[15px] py-[5px] duration-100">Bildirimler</div>
          {announcements?.map((item: any) => (
            <div className="flex align-center gap-[10px] px-[15px] py-[15px] border-b-[1px] hover:bg-[#F8F8F8] ">
              <div>
                <div className="w-[5px] h-[5px] mt-[8px] rounded-full bg-[#7059EF]"></div>
              </div>
              <div className="flex flex-col">
                <div className="flex align-center gap-[10px]">
                  <div>{item.title}</div>
                  {/* <div className="flex text-[12px] align-center justify-center text-[#8992A6]">
                    {localeStringConverter(item?.createdAt)}
                  </div> */}
                </div>
                <div className="text-[#8992A6]">{item.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isOpen &&

        <ProfileModal setIsOpen={setIsOpen} />
      }
    </>
  );
};

export default ChooseAppMain;
